<template>
  <div class="upload-table">
    <div class="title">
      {{material.elec_name}}

    </div>

    <div class="content">
      <!-- 合格不合格的章 -->
      <div class="icon-verify" :class="{
        passed: material.upload[0] && material.upload[0].elec_status === materialConstants.ELEC_STATUS.qualified_0,
        'not-pass': material.upload[0] && material.upload[0].elec_status === materialConstants.ELEC_STATUS.unqualified_3
      }"></div>
      <el-form :model="formInfo" ref="tableForm">
        <table class="material-table">
          <thead>
            <tr>
              <th width="50%">收集信息</th>
              <th width="50%">用户填写</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in formInfo.table_content" :key="index">
              <td>
                <div class="question-box">
                  <div class="required">{{ item.is_required ? '*' : '' }}</div>
                  <div class="question-value">{{ item.question }}</div>
                </div>
              </td>
              <td>
                <div class="answer-box" v-if="forbidUpload || !isEdit">{{item.answer}}</div>
                <el-form-item v-else :prop="`table_content.${index}.answer`" :rules="{ required: item.is_required, message: '请输入' }">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 3 }"
                    v-model="item.answer"
                    placeholder="请输入"
                    :maxlength="500"
                    :disabled="forbidUpload || !isEdit"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="footer-btn-box" v-if="!forbidUpload">
          <el-button v-if="!isEdit" class="btn" type="primary" @click="isEdit = true" >修改信息</el-button>
          <template v-else>
            <el-button class="btn" :loading="btnLoading" @click="cancelInfo">取消</el-button>
            <el-button class="btn" type="primary" :loading="btnLoading" @click="saveInfo" >保存</el-button>
          </template>
  
        </div>
      </el-form>

      <!-- 资料不完善备注 -->
      <memo class="memo" v-if="material.upload[0] && material.upload[0].memo" :memo-content="material.upload[0].memo"></memo>
    </div>
  </div>
</template>

<script>
import Http from '@/libs/http';
import uploadService from '../../services/upload-service';
import materialConstants from '../../constants/material-constants';
import applicantConstants from '../../constants/applicant-constants';
import memo from './memo';

export default {
  components: {
    memo,
  },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    material: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    // 是否重新上传
    isReupload: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    isOptional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      materialConstants,
      formInfo: {
        table_content: [],
      },
      btnLoading: false,
      isEdit: false, // 是否可编辑
    };
  },
  computed: {
    // 是否禁用上传
    forbidUpload() {

      // 重新上传
      if (this.isReupload) {

        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return false;
        }

        const isApplicantVerifyNotPass = this.applicant.applicant_status === applicantConstants.STATUS.verifyNotPassed_2;
        
        // 申请人不是资料不完善，都禁用
        if (!isApplicantVerifyNotPass) {
          return true;
        }

        // 一项都没有的时候需要禁用上传(出现在用户下单的时候没有上传资料，资料不完善的时候也没有需补充资料，但是此时需要展示，且不能上传)
        const isEmptyUpload = Boolean(!this.material.upload[0].url);

        // 单页资料预审通过
        const isVerifyPassed = this.material.upload[0] && this.material.upload[0].elec_status === materialConstants.ELEC_STATUS.qualified_0;
        const isVerifyNotPass = this.material.upload[0] && this.material.upload[0].elec_status === materialConstants.ELEC_STATUS.unqualified_3;

        // 暂不上传
        const isMaterialSelectRefuseToUpload =
          this.material.upload[0] &&
            this.material.upload[0].elec_status === materialConstants.ELEC_STATUS.waittingForVerified_2 &&
              this.material.upload[0].special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6;

        // 需补充资料
        const isMaterialNeededUpload =
          this.material.upload[0] &&
            this.material.upload[0].elec_status === materialConstants.ELEC_STATUS.waittingForUploadMaterial_1 &&
              this.material.upload[0].special_code === materialConstants.SPECIAL_CODE.materialRequired_5;

        // 如果是需补充资料或者资料不完善，直接启用
        if (isMaterialNeededUpload || isVerifyNotPass) {
          return false;
        }
        return isEmptyUpload || isVerifyPassed || isMaterialSelectRefuseToUpload;
      }

      // 不是重新上传都不禁用
      return false;
    },
    materialTableContent() {
      try {
        return this.material.upload[0].table_content;
      } catch (error) {
        return [];
      }
    },
  },
  created() {
    this.initTableContent();
  },
  methods: {
    initTableContent(options = {}) {
      // 如果填写过，取upload里面的，否则取资料里面的
      const hasTableContent = this.material.upload[0] && this.material.upload[0].table_content && this.material.upload[0].table_content.length;
      this.formInfo = {
        table_content: hasTableContent ?
          JSON.parse(JSON.stringify(this.material.upload[0].table_content)) :
          JSON.parse(JSON.stringify(this.material.table_content)),
      };

      if (!options.onlyResetTableContent) {
        // 包含表格，则需要点击编辑
        this.isEdit = !hasTableContent && this.isRequired;
      }
    },
    saveInfo() {
      this.$refs.tableForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请检查标红字段');
          return; 
        }
        this.btnLoading = true;
        Http.post('/applicant_material_table_submit', {
          order_applicant_id: this.applicant.order_applicant_id,
          elec_id: this.material.elec_id,
          table_content: this.formInfo.table_content,
        }).then((data) => {
          this.$message.success('保存成功');
          if (this.material.upload[0]) {
            // 编辑
            this.material.upload[0].url = data.url;
            this.material.upload[0].memo = '';
            this.material.upload[0].elec_status = materialConstants.ELEC_STATUS.waittingForVerified_2;
            this.material.upload[0].special_code = 0;
            this.material.upload[0].table_content = JSON.parse(JSON.stringify(this.formInfo.table_content));
          } else {
            // 新增
            const uploadItem = uploadService.createEmptyElecUploadItem({
              pos: 0,
              elec_status: materialConstants.ELEC_STATUS.waittingForVerified_2,
              table_content: JSON.parse(JSON.stringify(this.formInfo.table_content)),
              url: data.url,
            });
            this.material.upload.push(uploadItem);
          }
          this.isEdit = false;
          this.btnLoading = false;
        }).catch(() => {
          this.btnLoading = false;
        });
      });
    },
    cancelInfo() {
      this.initTableContent({ onlyResetTableContent: true });
      this.isEdit = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';
.upload-table {
  line-height: 1;
  background-color: #fff;
  .title {
    padding: 30px 30px 20px 30px;
    display: flex;
    align-items: center;
  }
  .content {
    padding: 0 30px 30px 30px;
    position: relative;
    .icon-verify{
      position: absolute;
      right: 30px;
      top: 0;
      width: 70px;
      height: 60px;
      &.passed{
        background: url(../../assets/imgs/upload/pass.png) no-repeat center / 100% 100%;
      }
      &.not-pass{
        background: url(../../assets/imgs/upload/not-pass.png) no-repeat center / 100% 100%;
      }
    }
    .material-table{
      width: 100%;
      max-width: 100%;
      border: 1px solid #E9EEF2;
      border-bottom: none;
      border-collapse:collapse;
      font-size: 14px;
      line-height: 20px;
      thead{
        tr{
          th{
            color: #2F333D;
            padding: 12px 20px;
            cursor: default;
            white-space: nowrap;
            border-bottom: 1px solid #E9EEF2;
            border-right: 1px solid #E9EEF2;
            background: #F7F8FA;
            text-align: left;
          }
        }
      }
      tbody{
        tr{
          td{
            padding: 20px;
            color: #2F333D;
            border-bottom: 1px solid #E9EEF2;
            border-right: 1px solid #E9EEF2;
          }
        }
      }

      .question-box{
        display: flex;
        align-items: flex-start;
        .required{
          flex-shrink: 0;
          color: #FF5A60;
          width: 12px;
        }
        .question-value{
          flex-grow: 1;
          overflow: hidden;
          white-space: pre-wrap;
          color: rgba(119,119,119,0.88);
          word-break: break-all;
        }
      }
      .answer-box{
        white-space: pre-wrap;
        word-break: break-all;
      }
    }

    .footer-btn-box{
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      gap: 10px;
      .btn{
        width: 174px;
      }
    }
    .memo{
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-table.vue